import generalSection from "../_section/section.class";
import {adminBusinessAccountStatementUpload, userBusinessAccountStatementUpload,} from "./upload";
import DataForm from "./DataForm";
import ApplicationForm from "./ApplicationForm";

export class userBusinessAccountStatementSection extends generalSection {
    constructor(request, mortgage, props, statementUploadFactory = null) {
        super(request, mortgage, props, statementUploadFactory ?? userBusinessAccountStatementUpload);
        // Add missing date error
        this.uploads.sort((a, b) => {
            if (!a.isActive) {
                return 1
            }
            if (!b.isActive) {
                return -1
            }
            if (!a?.dateData?.range?.from?.date) { // no dates to go top
                return -1
            }
            if (!b?.dateData?.range?.from?.date) {

                return 1
            }
            if (a.dateData.range.from.date.isSame(b.dateData?.range.from.date, 'day')) {
                return 0; // If dates are the same, keep original order
            }
            return a.dateData.range.from.date.isBefore(b.dateData.range.from.date) ? 1 : -1;
        });
        // Set array of the upload ranges that we have (corrected for overlapping dates & ignoring alignment dates)
        this.setUploadsRanges(
            (() => {
                const activeUploads = [...this.uploads].reverse().filter(it => it.isActive && it.isVerifiable);
                return activeUploads.flatMap((upload, uploadIndex) => {
                    if (!upload?.dateData?.range?.ok) {
                        return [];
                    }
                    const nextUploadWithOpening = activeUploads.find((it, i) => i > uploadIndex && it?.dateData?.range?.from?.date);
                    const openingDateOfNextUpload = nextUploadWithOpening ? nextUploadWithOpening?.dateData?.range?.from?.date : null;
                    // if there are start or end props available, use them, as they are the dates on the alignment endDate/startDate

                    let thisEnd = upload?.dateData?.range?.to ? upload.dateData.range.to : null
                    let thisStart = upload?.dateData?.range?.from ? upload.dateData.range.from : null


                    // this now updates the current upload end date, if the next upload opening date is before it
                    if (thisEnd?.date && openingDateOfNextUpload && openingDateOfNextUpload.local().startOf('day').isBefore(thisEnd.date)) {
                        let neededEndDate = openingDateOfNextUpload
                        const balanceFoundOnThisDay = null // upload.balances.find(it => it.date.isSame(neededEndDate, 'day'));
                        if (balanceFoundOnThisDay) {
                            thisEnd = balanceFoundOnThisDay;
                        } else {
                            thisEnd = {
                                date: neededEndDate,
                                balance: null // to detect if null to make error later!
                            }
                        }
                    }
                    return [
                        {
                            start: thisStart,
                            end: thisEnd,
                            uploadId: upload.id,

                        }
                    ]
                })
            })()
        )
    }
}

export class adminBusinessAccountStatementSection extends userBusinessAccountStatementSection {
    constructor(request, mortgage, props) {
        super(request, mortgage, props, adminBusinessAccountStatementUpload);
        this.DataForm = DataForm
        this.ApplicationForm = ApplicationForm
        this.sortByDateProp('startDate')
        this.setProblems(this.getProblems())
    }


    getProblems() {
        const problems = this.problemsList.universalVerifiedUploadProblems();
        return problems;
    }

    getSectionSummary = () => {
        return [
            {
                name: this.personalTitle,
                tags:[{
                    name: 'End Date',
                    value: this.values?.endDate?.format('D MMM YYYY') || 'Not Provided',
                }]
            }
        ]
    }
}